import React from 'react'

import { BodyText } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useSelector } from 'react-redux'

import { HiddenFavouritesData } from 'features/favourites/duck/types'
import { FavouritesHiddenItemsProps } from 'features/favourites/types'
import { RootState } from 'redux/types'

import { getFavouritesHiddenItems } from '../../../../duck/selectors'

const FavouritesHiddenItems: React.FC<FavouritesHiddenItemsProps> = ({
  className,
}: FavouritesHiddenItemsProps) => {
  const favouritesHiddenItems = useSelector((state: RootState) => getFavouritesHiddenItems(state))

  return (
    <>
      {favouritesHiddenItems ? (
        <ul>
          {favouritesHiddenItems.map((item: HiddenFavouritesData) => (
            <BodyText
              Tag="li"
              key={`${item.code}-${item.title}-AccessibilityHiddenFavourites`}
              aria-live="polite"
              srOnly
              className={className}
            >
              {item.title}
              {item.removed && getLabelFromStorage('removed.item.accessibility')}
            </BodyText>
          ))}
        </ul>
      ) : null}
    </>
  )
}

export default FavouritesHiddenItems
